function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ongd2yoeua",
  d: "M0 0h15.204v7.187H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "eyt4o1ut4c",
  d: "M0 0h15.204v7.187H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 7.917)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "nax3axu86b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ongd2yoeua"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.923 1.46H4.836V.768A.777.777 0 0 0 3.559.181L.273 3.006A.773.773 0 0 0 .27 4.181l3.29 2.823a.776.776 0 0 0 1.276-.588v-.691h6.384a3.987 3.987 0 0 0 3.984-3.984.282.282 0 0 0-.281-.281z",
  fill: "#84898D",
  mask: "url(#nax3axu86b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-180 7.602 3.593)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "8aekktf2jd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eyt4o1ut4c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.923 1.46H4.836V.768A.777.777 0 0 0 3.559.181L.273 3.006A.773.773 0 0 0 .27 4.181l3.29 2.823a.776.776 0 0 0 1.276-.588v-.691h6.384a3.987 3.987 0 0 0 3.984-3.984.282.282 0 0 0-.281-.281z",
  fill: "#84898D",
  mask: "url(#8aekktf2jd)"
})));

var SvgExchangeArrow = function SvgExchangeArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExchangeArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exchange-arrow.e8b0a9f1.svg";
export { ForwardRef as ReactComponent };